/* eslint-disable import/extensions, no-mixed-operators, eqeqeq,
 no-cond-assign, no-plusplus, no-bitwise */
/* global Image, document, FileReader,  */
import React, { PureComponent } from 'react'

const withImageHandling = ComposedComponent =>
  class extends PureComponent {
    constructor(props) {
      super(props)
      this.getOrientation = this.getOrientation.bind(this)
      this.resetOrientation = this.resetOrientation.bind(this)
      this.removeMetaData = this.removeMetaData.bind(this)
    }

    // get the EXIF orientation code of the uploaded image (to preserve phone upload orientation)
    getOrientation(file, callback) {
      const reader = new FileReader()

      reader.onload = function onread(event) {
        const view = new DataView(event.target.result)

        if (view.getUint16(0, false) != 0xffd8) return callback(-2)

        const length = view.byteLength
        let offset = 2

        while (offset < length) {
          const marker = view.getUint16(offset, false)
          offset += 2

          if (marker == 0xffe1) {
            if (view.getUint32((offset += 2), false) != 0x45786966) {
              return callback(-1)
            }
            const little = view.getUint16((offset += 6), false) == 0x4949
            offset += view.getUint32(offset + 4, little)
            const tags = view.getUint16(offset, little)
            offset += 2

            for (let i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) == 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little))
              }
            }
          } else if ((marker & 0xff00) != 0xff00) break
          else offset += view.getUint16(offset, false)
        }
        return callback(-1)
      }

      reader.readAsArrayBuffer(file.slice(0, 64 * 1024))
    }

    // reset photo's original orientation
    resetOrientation(srcBase64, srcOrientation, callback) {
      const img = new Image()

      img.onload = () => {
        const width = img.width
        const height = img.height

        this.setState({ width, height })
        if (this.props.onImageData) {
          this.props.onImageData({ width, height })
        }
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        // set proper canvas dimensions before transform & export
        if (srcOrientation > 4 && srcOrientation < 9) {
          canvas.width = height
          canvas.height = width
        } else {
          canvas.width = width
          canvas.height = height
        }

        // transform context before drawing image
        switch (srcOrientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0)
            break
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height)
            break
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height)
            break
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0)
            break
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0)
            break
          case 7:
            ctx.transform(0, -1, -1, 0, height, width)
            break
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width)
            break
          default:
            break
        }

        // draw image
        ctx.drawImage(img, 0, 0)

        // export base64
        callback(canvas.toDataURL('image/jpeg', 0.6))
      }

      img.src = srcBase64
    }

    // need to remove file metaData because s3 reads it as invalid encoding
    // e.g. data:image/jpeg;base64,{encodedData}, we just return 'encodedData'
    removeMetaData(fileData) {
      return fileData.split('base64,').pop()
    }

    render() {
      return (
        <ComposedComponent
          {...this.props}
          resetOrientation={this.resetOrientation}
          getOrientation={this.getOrientation}
          removeMetaData={this.removeMetaData}
          uploadFile={this.uploadFile}
        />
      )
    }
  }

export default withImageHandling



// WEBPACK FOOTER //
// ./src/HOCs/withImageHandling.js